import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { RiCloseLargeFill } from 'react-icons/ri';
import ProductItem from './ProductItem';
import RatePlanItem from './RatePlanItem';
import SuggestionsSection from './SuggestionsSection';
import './DefaultLayout.scss';

const DefaultLayout = ({
                           apiData,
                           translation,
                           recentSearchesList,
                           removeSearch,
                           handleInputChange,
                           handleProductClick,
                           originUrlRedirection,
                           lang,
                           defaultImgUrl,
                           strapiEndpoint
                       }) => {
    return (
        <div className="default-layout">
            <div className="left-column">
                {recentSearchesList && recentSearchesList.length > 0 && (
                    <div>
                        <h4>{translation('recentSearches')}</h4>
                        <ul>
                            {recentSearchesList.map((recent, index) => (
                                <li key={index}>
                                    <button
                                        className="search-item"
                                        onClick={() => {
                                            handleInputChange({ target: { value: recent } });
                                        }}
                                    >
                                        <FaSearch /> {recent}
                                    </button>
                                    &nbsp;
                                    <button
                                        className="search-item"
                                        onClick={() => {
                                            removeSearch(recent);
                                        }}
                                    >
                                        <RiCloseLargeFill />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {apiData.hotSearches && apiData.hotSearches.length > 0 && (
                    <div>
                        <h4>{translation('hotSearches')}</h4>
                        <ul>
                            {apiData.hotSearches.map((search, index) => (
                                <li key={index}>
                                    <button
                                        className="search-item"
                                        onClick={() => {
                                            handleInputChange({ target: { value: search } });
                                        }}
                                    >
                                        <FaSearch /> {search}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <SuggestionsSection
                    suggestions={apiData.suggestions}
                    translation={translation}
                    originUrlRedirection={originUrlRedirection}
                />
            </div>

            {(apiData?.products || apiData?.services) && (
                <div className="middle-column" style={{borderLeft: "1px solid #6F6F6F"}}>
                    {apiData?.products?.length > 0 && <>
                         <h4>{translation('topProducts')}</h4>
                        <ul>
                            {apiData?.products.map((item, index) => {
                                return (
                                    <ProductItem
                                        key={index}
                                        item={item}
                                        originUrlRedirection={originUrlRedirection}
                                        translation={translation}
                                        handleProductClick={handleProductClick}
                                    />
                                );
                            })}
                        </ul>
                    </>}
                    {apiData?.services?.length > 0 && <>
                        <h4>{translation('topServices')}</h4>
                        <ul>
                            {apiData?.services.map((item, index) => {
                                return (
                                    <RatePlanItem
                                        key={index}
                                        item={item}
                                        originUrlRedirection={originUrlRedirection}
                                        translation={translation}
                                        handleProductClick={handleProductClick}
                                        lang={lang}
                                    />
                                );
                            })}
                        </ul>
                    </>}

                </div>
            )}
            <div className="right-column">
                <h4>{translation('discoverMore')}</h4>
                <div className="banner-fix">
                    <img  src={strapiEndpoint + defaultImgUrl}/>
                </div>
            </div>
        </div>
    );
};

export default DefaultLayout;
